import api from './interceptor';

const BASE_URL_V2 = 'api/v2/contact';

export default {
  // API Version 2
  getContacts: (params = {}) => api.get(`${BASE_URL_V2}`, { params }),
  addContact: params => api.post(`${BASE_URL_V2}`, params),
  deleteContacts: (id, params = {}) => api.delete(`${BASE_URL_V2}/${id}`, { params }),
};
